import {
  Brand,
  PageType,
  SubVertical,
  FinnLegendarySubVertical
} from '@schibsted-nmp/advertising-shared';

const LOW_PERFORMING_SUBVERTICALS = new Set<SubVertical>([
  SubVertical.Motorcycles,
  SubVertical.Boats,
  SubVertical.Industry
]);

function isLowPerformingSubvertical(
  subVertical: '' | SubVertical | FinnLegendarySubVertical | null | undefined
): boolean {
  return LOW_PERFORMING_SUBVERTICALS.has(subVertical as SubVertical);
}

export function isLowPerformingSubverticalSection(
  brand: Brand | undefined,
  pageType: PageType | undefined,
  subVertical: '' | SubVertical | FinnLegendarySubVertical | null | undefined
): boolean {
  return (
    brand === Brand.Finn &&
    pageType === PageType.Section &&
    isLowPerformingSubvertical(subVertical)
  );
}
